import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFileImport, faGlobe, faShieldAlt, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge, BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useToast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import { copy } from "@/utils/clipboard";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowIndicators',
    props: {
        workflow: null,
        publishedView: { type: Boolean },
        noEditTime: { type: Boolean },
        filterable: { type: Boolean }
    },
    emits: ["updateFilter"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faFileImport, faGlobe, faShieldAlt, faUsers, faUser);
        // TODO: replace me with a proper definition
        const router = useRouter();
        const userStore = useUserStore();
        const publishedTitle = computed(() => {
            if (props.workflow.published && !props.publishedView) {
                return "Published workflow" + (props.filterable ? ". Click to filter published workflows" : "");
            }
            else if (userStore.matchesCurrentUsername(props.workflow.owner)) {
                return "Published by you" + (props.filterable ? ". Click to view all published workflows by you" : "");
            }
            else {
                return (`Published by '${props.workflow.owner}'` +
                    (props.filterable ? `. Click to view all published workflows by '${props.workflow.owner}'` : ""));
            }
        });
        const shared = computed(() => {
            return !userStore.matchesCurrentUsername(props.workflow.owner);
        });
        const sourceType = computed(() => {
            const { url, trs_server, trs_tool_id } = props.workflow.source_metadata || {};
            const trs = trs_server || trs_tool_id;
            if (url) {
                return "url";
            }
            else if (trs) {
                return `trs_${trs}`;
            }
            else {
                return "";
            }
        });
        const sourceTitle = computed(() => {
            if (sourceType.value.includes("trs")) {
                return `Imported from TRS ID (version: ${props.workflow.source_metadata.trs_version_id}). Click to copy ID`;
            }
            else if (sourceType.value == "url") {
                return `Imported from ${props.workflow.source_metadata.url}. Click to copy link`;
            }
            else {
                return `Imported from ${props.workflow.source_type}`;
            }
        });
        const { success } = useToast();
        function onCopyLink() {
            if (sourceType.value == "url") {
                copy(props.workflow.source_metadata.url);
                success("URL copied");
            }
            else if (sourceType.value.includes("trs")) {
                copy(props.workflow.source_metadata.trs_tool_id);
                success("TRS ID copied");
            }
        }
        function onViewMySharedByUser() {
            router.push(`/workflows/list_shared_with_me?owner=${props.workflow.owner}`);
            emit("updateFilter", "user", `'${props.workflow.owner}'`);
        }
        function onViewUserPublished() {
            router.push(`/workflows/list_published?owner=${props.workflow.owner}`);
            emit("updateFilter", "user", `'${props.workflow.owner}'`);
        }
        function getStepText(steps) {
            if (steps === 1) {
                return "1 step";
            }
            else {
                return `${steps} steps`;
            }
        }
        return { __sfc: true, props, emit, router, userStore, publishedTitle, shared, sourceType, sourceTitle, success, onCopyLink, onViewMySharedByUser, onViewUserPublished, getStepText, faFileImport, faGlobe, faShieldAlt, faUser, faUsers, FontAwesomeIcon, BBadge, BButton, UtcDate };
    }
});
